'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { CmsHtmlContent } from '@/components/CmsHtmlContent';
import { VehicleKVPTable } from '@/components/Vehilces/VehicleKVPTable';
import { VehicleSpecsTable } from '@/components/Vehilces/VehicleSpecsTable';
import { VehicleSpecsTabPanel } from '@/components/Vehilces/VehicleSpecsTabs/VehicleSpecsTabPanel';
import type { VehicleSpecsTab } from '@/components/Vehilces/VehicleSpecsTabs/VehicleSpecsTabSelector';
import { VehicleSpecsTabSelector } from '@/components/Vehilces/VehicleSpecsTabs/VehicleSpecsTabSelector';
import type { CmsVehicle } from '@/services/cms/models/CmsVehicle';
export type VehicleSpecsTabsProps = {
  vehicle: CmsVehicle;
};
export function VehicleSpecsTabs(t0) {
  const $ = _c(30);
  const {
    vehicle
  } = t0;
  const [activeTab, setActiveTab] = React.useState("description");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <VehicleSpecsTabSelector onChange={tab => setActiveTab(tab)} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== vehicle.description) {
    t2 = vehicle.description ? <CmsHtmlContent html={vehicle.description} /> : null;
    $[1] = vehicle.description;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== activeTab || $[4] !== t2) {
    t3 = <VehicleSpecsTabPanel value={activeTab} name="description">{t2}</VehicleSpecsTabPanel>;
    $[3] = activeTab;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== vehicle) {
    t4 = <VehicleSpecsTable vehicle={vehicle} />;
    $[6] = vehicle;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== activeTab || $[9] !== t4) {
    t5 = <VehicleSpecsTabPanel value={activeTab} name="specifications">{t4}</VehicleSpecsTabPanel>;
    $[8] = activeTab;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== vehicle.externalFeatures) {
    t6 = Object.entries(vehicle.externalFeatures).map(_temp);
    $[11] = vehicle.externalFeatures;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <VehicleKVPTable records={t6} />;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== activeTab || $[16] !== t7) {
    t8 = <VehicleSpecsTabPanel value={activeTab} name="external-features">{t7}</VehicleSpecsTabPanel>;
    $[15] = activeTab;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== vehicle.internalFeatures) {
    t9 = Object.entries(vehicle.internalFeatures).map(_temp2);
    $[18] = vehicle.internalFeatures;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <VehicleKVPTable records={t9} />;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== activeTab || $[23] !== t10) {
    t11 = <VehicleSpecsTabPanel value={activeTab} name="internal-features">{t10}</VehicleSpecsTabPanel>;
    $[22] = activeTab;
    $[23] = t10;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t3 || $[27] !== t5 || $[28] !== t8) {
    t12 = <>{t1}{t3}{t5}{t8}{t11}</>;
    $[25] = t11;
    $[26] = t3;
    $[27] = t5;
    $[28] = t8;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  return t12;
}
function _temp2(t0) {
  const [label_0, value_0] = t0;
  return {
    label: label_0,
    value: value_0
  };
}
function _temp(t0) {
  const [label, value] = t0;
  return {
    label,
    value
  };
}